import { useAppState } from '../appState'

/**
 * Reads the Cognito role from the idToken payload. `appState.auth` holds two different
 * shapes depending on which action populated it: `AUTH_CHANGE` stores an
 * `Auth.currentSession()` result (payload at `auth.idToken`), while `SIGN_IN` stores the
 * `Auth.signIn()` CognitoUser (payload at `auth.signInUserSession.idToken`). Check both, or
 * an admin who just signed in reads as non-admin until the next full page load.
 */
const useAdmin = () => {
  let [appState] = useAppState()
  let isAdmin = false
  const auth: any = appState.auth
  let userRole =
    auth?.idToken?.payload['custom:user_role'] ??
    auth?.signInUserSession?.idToken?.payload['custom:user_role']
  if (userRole === 'admin' || userRole === 'super-admin') isAdmin = true

  return [isAdmin, userRole]
}

export default useAdmin
